export default __webpack_public_path__ + "fonts/78d94883476de96376ef21827ddb5a08.svg";